import { Link } from '@mui/material';
import React from 'react';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

interface IViewAll {
    onClickViewAll?: () => void;
    themeStyle: ColorScheme;
}
export const ViewAll: React.FC<IViewAll> = ({ onClickViewAll, themeStyle }) => {
    return (
        <Link
            style={{
                textAlign: 'left',
                fontSize: 16,
                fontStyle: 'normal',
                fontWeight: '600',
                color: theme[themeStyle].primary_orange,
                fontFamily: FONT_ENUM.MAIN_BOLD,
            }}
            sx={{
                textDecoration: 'none',
                '&:hover': {
                    textDecoration: 'none',
                    cursor: 'pointer',
                },
            }}
            onClick={() => onClickViewAll && onClickViewAll()}>
            View all
        </Link>
    );
};
